<template>
<span
	@click="onRisk"
	v-if="score > 0"
	:title="`Rugcheck Risk Score: ${score}`"
>
						<span
							style="line-height: 0.875em"
							v-if="isNormalScore(score)"
						>✅</span
						>
						<span
							style="line-height: 0.875em"
							v-else-if="isWarnScore(score)"
						>⚠️</span
						>
						<span
							style="line-height: 0.875em"
							v-else-if="score < 1_000_000"
						>🚨</span
						>
						<span style="line-height: 0.875em" v-else>💀</span>
						<span
							class="small ml-1"
							:class="{
								'text-success': score < 2000,
								'text-warn': score >= 2000,
								'text-danger': score > 5000,
							}"
						>{{ formatAmount(score, 0) }}</span
						>
					</span>
</template>

<script>

export default {
	name: "RiskScore",
	props: {
		mint: {
			type: String
		},
		score: {
			type: Number,
			required: true,
			default() {
				return 0
			}
		}
	},
	methods: {
		isNormalScore: function (score) {
			return score >= 0 && score < 2000;
		},
		isWarnScore: function (score) {
			return score >= 2000 && score < 5000;
		},
		onRisk: function (e) {
			e.preventDefault();
			e.stopPropagation();
			window.open(
				`https://rugcheck.xyz/tokens/${this.props.mint}?network=fogo`,
				"_blank"
			);
		},

		formatAmount: function (price, decimals = 2) {
			if (price > 999e12) { // 999 trillion
				return `>999T`
			}

			const num = Number(price?.toPrecision(7) || 0);
			if (num < 1000) return `${num.toFixed(decimals)}`;
			if (num < 1000000) return `${(num / 1000).toFixed(decimals)}K`;
			if (num < 1000000000) return `${(num / 1000000).toFixed(decimals)}M`;
			if (num < 1000000000000) return `${(num / 1000000000).toFixed(decimals)}B`;
			if (num < 1000000000000000) return `${(num / 1000000000000).toFixed(decimals)}T`;
			if (num < 1000000000000000000) return `${(num / 1000000000000000).toFixed(decimals)}Q`;
			return `>9999T`;
		}
	},
}
</script>

<style scoped>

</style>